document.addEventListener('change', (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  const optionInputs = [...form.querySelectorAll('input[type="radio"]')];
  if (!optionInputs.length) return;

  // Shopify's product form will still submit the selected variant when a theme
  // uses variant selection JS. This lightweight starter keeps the UI clean;
  // for advanced variant media/pricing, extend this file.
});
